import { Component } from '@angular/core';
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: 'app-authority-information',
  templateUrl: './authority-information.component.html',
  styleUrls: ['./authority-information.component.css']
})
export class AuthorityInformationComponent {

  protected readonly faInfoCircle = faInfoCircle;
}
